module.exports = __webpack_public_path__ + "da685564fee9a9a7a3393377aab450a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/topbar/logo_small.png
// module id = 334
// module chunks = 0